import script from "./DashboardTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardTable.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2450d8"]])

export default __exports__